import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M54.026 50l19.34-19.34a2.847 2.847 0 1 0-4.026-4.026L50 45.974l-19.34-19.34a2.847 2.847 0 1 0-4.026 4.026L45.974 50l-19.34 19.34a2.847 2.847 0 1 0 4.026 4.026L50 54.026l19.34 19.34a2.847 2.847 0 1 0 4.026-4.026z'

const IconCross: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconCross
